export default {
  inicioParalisacao: {
    value: null,
    required: true,
    state: null
  },
  terminoParalisacao: {
    value: null,
    required: false,
    state: null
  },
  responsavelParalisacao: {
    value: null,
    options: [
      {value: 0, text: 'CLIENTE'},
      {value: 1, text: 'ZOPONE'},
      {value: 2, text: 'EMBARGADO'}
    ],
    required: true,
    state: null
  },
  observacao: {
    value: null,
    newValue: null,
    required: true,
    state: null
  },
  obraID: {
    value: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/components/stoppage/stoppage-form.js